<template>
  <div
    :id="data.Id"
    :data-elementindex="getElementIndex"
    :style="getShapeStyles"
    :data-translateX="data.X"
    :data-translateY="data.Y"
    :data-rotate="data.RotateDegree"
    :class="[getLocked ? 'untarget' : 'target ']"
    class="position-absolute d-flex object-add"
    data-type="shape">
    <svg
      v-if="getShapeType === 'rectangle'"
      :viewBox="data.isNewObject? '': getShapeViewBox"
      :width="data.Width"
      :height="data.Height"
      :style="getSvgStyle"
      xmlns="http://www.w3.org/2000/svg">
      <linearGradient v-if="data.isGradient" :id="`gradient-${data.Id}-${uniqueId}`" :gradientTransform="`rotate(${data.gradient.angle})`">
        <stop  v-for="(color, index) of sortedColors" :key="index" :offset="`${color.position}%`" :stop-color="`${color.rgba}`"></stop>
      </linearGradient>
      <rect
        :width="data.Width"
        :height="data.Height"
        :style="getRectStyle"/>

    </svg>
    <svg
      v-if="getShapeType === 'ellipses'"
      :viewBox="data.isNewObject ? null: getShapeViewBox"
      :width="getEllipseWidth"
      :height="getEllipseHeight"
      :style="getSvgStyle"
      xmlns="http://www.w3.org/2000/svg">
      <linearGradient v-if="data.isGradient" :id="`gradient-${data.Id}-${uniqueId}`" :gradientTransform="`rotate(${data.gradient.angle})`">
        <stop  v-for="(color, index) of sortedColors" :key="index" :offset="`${color.position}%`" :stop-color="`${color.rgba}`"></stop>
      </linearGradient>
      <ellipse
        :cx="data.CurveCenterX"
        :cy="data.CurveCenterY"
        :rx="data.CurveHorizontalRadius"
        :ry="data.CurveVerticalRadius"
        :style="getEllipseStyle"/>
    </svg>
    <svg
      v-else-if="getShapeType === 'polygon'"
      ref="polygon-parent"
      :viewBox="getShapeViewBox"
      :width="data.polygonWidth"
      :height="data.polygonHeight"
      :style="getSvgStyle"
      xmlns="http://www.w3.org/2000/svg">
      <polygon
        ref="polygonRef"
        :points="data.PolygonPoints"
        :style="{fill:data.DefaultColor, stroke:data.StrokeColor, strokeWidth: `${data.StrokeWidth}px`}"/>
      />
    </svg>
    <div
      v-else-if="getShapeType === 'svgShapes'"
      v-html="data.svgContent"/>
  </div>
</template>
<script>
import { uuid } from 'vue-uuid';
export default {
  name:       'ObjectShape',
  components: {},
  props:      {
    data:         Object,
    elementIndex: Number,
    objectProps:  {
      type:    Object,
      default: {},
    },
  },
  data() {
    return { bbox: {},
    uniqueId: ''};
  },
  computed: {
    sortedColors() {
      return this.data.gradient.colors.slice().sort((a, b) => a.position - b.position);
    },
    isHFlipped: ({ objectProps }) => objectProps.IsHFlipped,
    isVFlipped: ({ objectProps }) => objectProps.IsVFlipped,
    getShapeViewBox() {
      const strokeWidth      = (this.data.StrokeWidth) ? this.data.StrokeWidth : 0;
      const strokeAdjustment = strokeWidth > 0 ? strokeWidth / 2 : 0;
      if (this.getShapeType === 'ellipses') {
        const x1 = this.data.CurveCenterX - this.data.CurveHorizontalRadius;
        const y1 = this.data.CurveCenterY - this.data.CurveVerticalRadius;

        return `${x1 - strokeAdjustment} ${y1 - strokeAdjustment} ${this.getEllipseWidth + strokeWidth} ${this.getEllipseHeight + strokeWidth}`;
      }
      if (this.getShapeType === 'polygon') {
        console.log('bbox is ', this.bbox);
        return `${this.data.initialX - (strokeAdjustment * 2)} ${this.data.initialY - (strokeAdjustment * 2)} ${this.data.polygonWidth + strokeWidth * 2} ${this.data.polygonHeight + strokeWidth * 2}`;
      }
      if (this.getShapeType === 'rectangle') {
        return `${this.data.initialX} ${this.data.initialY} ${this.data.Width} ${this.data.Height}`;
      }
    },
    getRectStyle() {
      const style = {
        fill: this.data.isGradient ? `url(#gradient-${this.data.Id}-${this.uniqueId})` : this.data.DefaultColor,
        stroke: this.data.StrokeColor, strokeWidth: `${this.data.StrokeWidth}px`
      }
      return style;
    },
    getEllipseStyle() {
      const style = {
        fill: this.data.isGradient ? `url(#gradient-${this.data.Id}-${this.uniqueId})` : this.data.DefaultColor,
        stroke: this.data.StrokeColor, strokeWidth: `${this.data.StrokeWidth}px`
      }
      return style;
    },
    getSvgStyle() {
      let scaleXwithFlip = this.data.svgScaleX * this.getHorizontalFlip;
      let scaleYwithFlip = this.data.svgScaleY * this.getVerticalFlip;
      if (this.getShapeType === 'rectangle') {
        scaleXwithFlip = this.getHorizontalFlip;
        scaleYwithFlip = this.getVerticalFlip;
      }
      return {
        transform:       `scale(${scaleXwithFlip},${scaleYwithFlip})`,
        transformOrigin: 'left top',
        verticalAlign:   this.getShapeType === 'polygon' ? 'top' : 'middle', // by default in style svg contain vertical align middle
        overflow:        'visible',
      };
    },
    getElementIndex() {
      return this.data.elementIndex;
    },
    getHorizontalFlip() {
      return this.data.isHFlipped === true ? -1 : 1;
    },
    getVerticalFlip() {
      return this.data.isVFlipped === true ? -1 : 1;
    },

    getShapeType() {
      return this.data.shapeType;
    },
    getShapeStyles() {
      const {
        X, Y, RotateDegree, scaleX, scaleY, DefaultColor, Width, Height, Alpha,
      } = this.data;
      return {
        transform:       `rotate(${RotateDegree}deg) scale(${scaleX * (this.isVFlipped && this.getShapeType != 'rectangle') ? -1 : 1},${scaleY * (this.isHFlipped && this.getShapeType != 'rectangle') ? -1 : 1})`,
        // backgroundColor: this.getShapeType === 'rectangle' ? DefaultColor : '',
        height:          Height !== 0 ? `${Height}px` : 'auto',
        width:           Width !== 0 ? `${Width}px` : 'auto',
        zIndex:          this.data.PdfSortOrder,
        display:         this.data.IsVisible ? 'flex !important' : 'none !important',
        alignItems:      'baseline',
        opacity:         parseFloat(Alpha) / 100,
        top:             `${Y}px`,
        left:            `${X}px`,

      };
    },
    getLocked() {
      return this.data.locked;
    },
    getEllipseWidth() {
      return this.data.CurveHorizontalRadius * 2;
    },
    getEllipseHeight() {
      return this.data.CurveVerticalRadius * 2;
    },
  },
  mounted() {
    this.uniqueId = uuid.v1();
    if (this.data.type == 'shape' && (this.data.shapeType == 'ellipses')) {
      const calculatedWidth  = parseInt(document.getElementById(this.data.Id).style.width) / parseInt(document.getElementById(this.data.Id).firstElementChild.getAttribute('width'));
      const calculatedHeight = parseInt(document.getElementById(this.data.Id).style.height) / parseInt(document.getElementById(this.data.Id).firstElementChild.getAttribute('height'));
      this.data.svgScaleX    = calculatedWidth || 1;
      this.data.svgScaleY    = calculatedHeight || 1;
    }
    if (this.$refs.polygonRef && this.$refs.polygonRef.getBBox().width > 0) { this.getBBoxCustom(this.$refs.polygonRef).then((response) => { this.bbox = response; }); }
  },
  updated() {
    this.$nextTick(() => {
      if (this.$refs.polygonRef && this.$refs.polygonRef.getBBox().width > 0) {
        this.getBBoxCustom(this.$refs.polygonRef).then((response) => {
          this.$refs['polygon-parent'].setAttribute('viewBox', `${response.x} ${response.y} ${response.width} ${response.height}`);
          console.log({
            x:      response.x, y:      response.y, width:  response.width, height: response.height,
          });
        });
      }
    });
  },
  methods: {
    async getBBoxCustom(el) {
      let bb   = el.getBBox();
      const ns = 'http://www.w3.org/2000/svg';

      /**
       * check element type
       * stroke properties and transformations
       */
      const type             = el.nodeName;
      const parent           = el.farthestViewportElement;
      const {
        a,
        b,
        c,
        d,
        e,
        f,
      } = parent.getScreenCTM().inverse().multiply(el.getScreenCTM());
      const matrixStr        = [a, b, c, d, e, f].map(val => +val.toFixed(3)).join(' ');
      const hasTransforms    = matrixStr !== '1 0 0 1 0 0';
      const style            = window.getComputedStyle(el);
      const hasStroke        = !!(style.strokeWidth && style.stroke);
      const hasStrokeLinecap = !!(hasStroke && style.strokeLinecap !== 'butt');
      const strokeWidth      = parseFloat(style.strokeWidth);


      /**
       * no stroke - no transforms:
       * return standard bBox
       */
      if (!hasStroke && hasTransforms) {
        console.log('standard bbox');
        return bb;
      }

      /**
       * no transforms and straight angles:
       * return standard bBox + stroke widths
       */
      if (
        (type === 'rect' || type === 'line')
          && !hasTransforms
      ) {
        if (type === 'line') {
          const isVertical   = +el.getAttribute('x1') === +el.getAttribute('x2');
          const isHorizontal = +el.getAttribute('y1') === +el.getAttribute('y2');

          if (hasStrokeLinecap || isHorizontal) {
            bb.y      -= strokeWidth / 2;
            bb.height += strokeWidth;
          }

          if (hasStrokeLinecap || isVertical) {
            bb.x     -= strokeWidth / 2;
            bb.width += strokeWidth;
          }
          return bb;
        }

        if (type === 'rect') {
          bb.x      -= strokeWidth / 2;
          bb.width  += strokeWidth;
          bb.y      -= strokeWidth / 2;
          bb.height += strokeWidth;
          return bb;
        }
      }


      const canvas = document.createElement('canvas');
      const ctx    = canvas.getContext('2d');


      // create temporary svg
      const svgTmp   = document.createElementNS(ns, 'svg');
      const elCloned = el.cloneNode(true);
      document.body.append(svgTmp);
      // document.body.append(canvas)

      // if transformed - wrap in group recalculate bbox
      if (hasTransforms) {
        const g = document.createElementNS(ns, 'g');
        g.append(elCloned);
        svgTmp.append(g);

        // update bbox
        bb = g.getBBox();
      } else {
        svgTmp.append(elCloned);
      }


      // crop viewBox to element to reduce pixel checks
      const strokeOffset = strokeWidth * 10;
      const {
        x,
        y,
        width,
        height,
      } = bb;


      const viewBoxNew = [
        Math.ceil(x - strokeOffset / 2),
        Math.ceil(y - strokeOffset / 2),
        Math.ceil(width + strokeOffset),
        Math.ceil(height + strokeOffset),
      ];

      svgTmp.setAttribute('viewBox', viewBoxNew.join(' '));
      const w = viewBoxNew[2];
      const h = viewBoxNew[3];

      /**
       * set height and width for Firefox
       */
      svgTmp.setAttribute('width', w);
      svgTmp.setAttribute('height', h);
      const svgURL = await new XMLSerializer().serializeToString(svgTmp);


      // draw to canvas
      canvas.width  = w;
      canvas.height = h;
      const img     = new Image();
      img.src       = `data:image/svg+xml; charset=utf8, ${encodeURIComponent(svgURL)}`;
      await img.decode();
      ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

      /**
       * get bbox from
       * opaque pixels
       */
      const data   = ctx.getImageData(0, 0, w, h).data;
      let currentX = 0;
      let currentY = 0;

      let xMin = x + w;
      let xMax = 0;
      let yMin = y + h;
      let yMax = 0;


      /**
       * loop through color array
       * every 4. item is new pixel
       */
      for (let i = 0; i < data.length; i += 4) {
        // separate array chunk into rgba values
        const [r, g, b, a] = [data[i], data[i + 1], data[i + 2], data[i + 3]];
        if (a > 0) {
          xMin = currentX < xMin ? currentX : xMin;
          xMax = currentX > xMax ? currentX : xMax;
          yMin = currentY < yMin ? currentY : yMin;
          yMax = currentY > yMax ? currentY : yMax;
        }

        // is new "pixel row" – increment y value, reset x to "0"
        if (currentX + 1 >= w) {
          currentX = 0;
          currentY++;
        } else {
          currentX++;
        }
      }


      // recalculate viewBox according to previous offset
      const bboxCanvas = {
        x:      xMin + viewBoxNew[0],
        y:      yMin + viewBoxNew[1],
        width:  xMax - xMin + 1,
        height: yMax - yMin + 1,
      };

      // remove tmp svg
      svgTmp.remove();
      return bboxCanvas;
    },
  },
};

</script>
<style scoped>
.animation-inprogress{
  transform-origin: center center !important;
}
.animation-over{
  transform-origin: left top !important;
}
</style>
